export default __webpack_public_path__ + "static/media/gallery - draught of living death_01.9f1215fd.jpg";